import axios from './companyHttp'

export interface OnTimeMetric {
  on_time: number
  measured: number
  unknown: number
  percent: number | null
}
export interface DriverPeriod {
  jobs: number
  gmv: string | null
  average_gmv: string | null
  revenue_per_mile: string | null
  planned_miles: number
  mileage_jobs: number
  revenue_jobs: number
  pickup: OnTimeMetric
  delivery: OnTimeMetric
}
export interface ComplianceWarning {
  label: string
  status: 'missing' | 'unknown' | 'expired' | 'expiring'
  expires_on: string | null
  onboarding_id: string | null
}
export interface DriverMetrics {
  id: string
  name: string
  team: { id: string | null; name: string }
  active: boolean
  metrics: { last_30: DriverPeriod; previous_30: DriverPeriod; lifetime: DriverPeriod }
  warnings: ComplianceWarning[]
  active_jobs: number
  last_completed_at: string | null
}
export interface DriverMetricsDetail extends DriverMetrics {
  safety_history: {
    label: string
    source: string
    available: boolean
    lifetime: number
    last_30: number
    unknown_dates: number
    updated_at: string | null
    events: { id: string; date: string | null; label: string }[]
  }[]
  personal: boolean
  updated_at: string
  weekly: { week: string; jobs: number; gmv: string | null }[]
  job_count: number
  jobs: {
    id: string
    human_id: string
    completed_at: string
    stops: {
      type_detail: string
      date_start: string | null
      date_end: string | null
      actual_arrival: string | null
      is_appointment_confirmed: boolean
    }[]
  }[]
}
export interface DriverMetricsDirectory {
  count: number
  results: (DriverMetrics & {
    safety: { score: string | null; status: string; as_of: string }
  })[]
  teams: { id: string; name: string }[]
  updated_at: string
}
export type MetricPeriod = 'last_30' | 'lifetime'
export const DRIVER_METRICS_PATH = '/company/performance/'

export async function getDriverMetrics(params: {
  search: string
  team?: string
  page: number
  ordering: string
  period: MetricPeriod
}): Promise<DriverMetricsDirectory> {
  return (await axios.get('/api/v3/driver-metrics/', { params })).data
}
export async function getDriverMetricDetail(
  id: string,
  period: MetricPeriod,
  page: number
): Promise<DriverMetricsDetail> {
  return (await axios.get(`/api/v3/driver-metrics/${id}/`, { params: { period, page } })).data
}
